import { useParseParams } from '@hooks/params';
import { QuoteOptionParams, quoteOptionParamsSchema } from '@models/Quote';

export const useQuoteOptionParams = () => {
  return useParseParams<QuoteOptionParams>(quoteOptionParamsSchema);
};
